<template>
  <div class="component-content sub-content">
    <div class="list-title">
      <label class="label-name">当前仓库/公司：</label>
      <el-select size="small" style="width:250px;" class="organization-select" v-model="houseId" placeholder="请选择仓库/公司">
        <el-option v-for="item in houseList" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
    </div>
    <div class="list-title" style="padding:5px 10px 8px;background:#f8f8f8;">
      <!-- 条件搜索 -->
      <h3 class="title" style="float:none;border-bottom:1px #ccc solid;margin-bottom:5px;">条件搜索<span class="tip"
          style="font-size:12px;">（搜索条件为选填, 然后点击搜索按钮进行搜索）</span></h3>
      <section>
        <label class="label-name">供应商：</label>
        <el-select size="small" filterable style="width:200px;" class="organization-select" v-model="form.supplierId"
          clearable placeholder="请选择供应商">
          <el-option v-for="item in supplierList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>

        <label class="label-name" style="margin-left:15px;">发票号码：</label>
        <el-input v-model="form.inVoice" size="small" placeholder="完整的发票号码" style="width:140px;"></el-input>
        <label class="label-name" style="margin-left:15px;">材料名称：</label>
        <el-input v-model="form.materialName" placeholder="材料名称关键字(模糊搜索)" size="small" style="width:230px;"></el-input>
      </section>
      <section style="margin-top:5px;">
        <div class="r">
          <a :href="baseURL + '/storage/material/in/detail/list/download?depId=' + form.depId + '&houseId=' + form.houseId + '&startTime=' + form.startTime + '&endTime=' + form.endTime + '&materialName=' + form.materialName + '&inVoice=' + form.inVoice + '&supplierId=' + form.supplierId + '&accesstoken=' + userData.accesstoken + '&number=' + form.number"
            style="float:right;position:relative;z-index:2;" target="_blank">
            <el-button type="primary" size="mini">入库材料明细表下载</el-button>
          </a>
        </div>

        <label class="label-name">单号：</label>
        <el-input v-model="form.number" size="small" placeholder="单号(模糊搜索)" style="width:140px;"></el-input>
        <label class="label-name" style="margin-left:15px;">时间：</label>

        <el-date-picker size="small" v-model="time" type="daterange" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期" value-format="yyyy-MM-dd">
        </el-date-picker>

        <!-- <el-date-picker v-model="form.startTime" size="small" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
          placeholder="开始时间"></el-date-picker><span style="width:30px;display:inline-block;text-align:center">至</span>
        <el-date-picker v-model="form.endTime" size="small" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
          placeholder="结束时间"></el-date-picker> -->


        <el-button type="success" @click="getLists()" size="mini">搜索</el-button>
      </section>
    </div>

    <div class="table-total">
      <span>材料入库合计数量：{{ total.sl }} 件</span>
      <span>总金额：{{ total.zj }} 元</span>
    </div>
    <el-table :data="paginationData" border style="width: 100%" v-loading="loading">
      <el-table-column label="入库单号" width="100px">
        <template slot-scope="scope">
          <a href="javascript:void(0)" @click="ShowMaterialInDetail(scope.row)">{{ scope.row.number }}</a>
        </template>
      </el-table-column>
      <el-table-column prop="houseName" width="120px" label="所属仓库">
      </el-table-column>
      <el-table-column prop="name" label="明细名称">
      </el-table-column>

      <el-table-column prop="unitName" align="center" width="70" label="计量单位">
      </el-table-column>
      <el-table-column prop="" label="数量" width="70px" align="center">
        <template slot-scope="scope">
          {{ scope.row.amount && parseFloat(scope.row.amount).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column label="单价(元)" width="70px">
        <template slot-scope="scope">
          {{ scope.row.price && parseFloat(scope.row.price).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="totalPrice" label="总价(元)" width="70px">
      </el-table-column>
      <el-table-column prop="inVoice" label="发票号码" width="100px">
      </el-table-column>
      <!-- <el-table-column prop="supplierName" label="供应商">
      </el-table-column> -->
      <el-table-column prop="time" label="入库时间" width="135px">
      </el-table-column>
    </el-table>

    <el-pagination v-if="filterData.length > pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length"
      @current-change="handleCurrentChange">
    </el-pagination>

    <material-in-detail v-on:hideDetail="hideDetail()" :detailStatus="detailStatus" :materialInData="materialInData">
    </material-in-detail>
  </div>
</template>

<script>
import {
  mapState
} from "vuex";

import UserInfo from '@/components/UserInfo'
import MaterialInDetail from '@/page/storage/components/materialInDetail'
export default {
  components: {
    UserInfo,
    MaterialInDetail,
  },
  computed: {
    ...mapState({
      organization: state => state.main.organization,
      userData: state => state.main.userData,
      managerStorage: state => state.storage.managerStorage,
    })
  },
  data() {
    return {
      baseURL: axios.defaults.baseURL,
      // 编辑入库单
      editMaterialInStatus: false,
      form: {
        houseId: '',
        startTime: '',
        endTime: '',
        materialName: '',
        inVoice: '',
        supplierId: '',
        number: '',
      },
      time: "",
      supplierList: '',
      // 入库单明细详情
      detailStatus: false,
      materialInData: "",

      houseId: 0,
      depId: "",
      houseList: "",

      organizationListData: [],
      noSelectOrganization: true,
      // 列表
      loading: true,
      pageSize: 20,
      currentPage: 1,
      listData: [],
      filterData: [],
      paginationData: [],

      // 合计
      total: {},
    }
  },
  created() {
    if (this.$route.params.houseId) {
      this.form.houseId = this.$route.params.houseId / 1
    }
    this.depId = this.userData.secDepIds.split(",")[0] / 1
    // 获取仓库列表
    this.getHouseList()

    // 获取供应商列表
    ajax.get('/supplier/list', {
      'type': 1
    }, (res) => {
      this.loading = false
      this.supplierList = res.vo.array
    })

    // 获取当前日期
    const currentDate = new Date();
    // 计算3个月前的日期
    const threeMonthsAgo = new Date();
    threeMonthsAgo.setMonth(currentDate.getMonth() - 3);
    // 格式化日期为 yyyy-MM-dd
    function formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需+1
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
    // 设置 this.time 数组
    this.time = [
      formatDate(threeMonthsAgo), // 索引0：3个月前的日期
      formatDate(currentDate)     // 索引1：当前日期
    ];
  },
  mounted() {
    this.organizationListData = this.organization[0].childDepts
    this.depId = this.userData.secDepIds.split(",")[0] / 1

    if (this.userData.secDepIds.split(",")[0] == "7") {
      this.noSelectOrganization = false
    }
  },
  methods: {
    // 编辑入库信息
    editMaterialIn() {
      ajax.post('/storage/material/in/edit', this.form, (res) => {
        this.getLists()
        this.editMaterialInStatus = false
      })
    },
    // 编辑按钮点击
    ShowMaterialInEdit(row) {
      this.editMaterialInStatus = true
      this.form.inId = row.id
      this.form.inVoice = row.inVoice
      this.form.supplierId = row.supplier.id
    },
    hideDetail() {
      this.detailStatus = false
    },
    // 显示入库单详情
    ShowMaterialInDetail(row) {
      // this.materialInData = row
      // this.detailStatus = true
    },
    // 获取仓库列表
    getHouseList() {
      ajax.get('/storage/house/list', {
        'depId': this.depId
      }, (res) => {
        this.houseList = [{
          id: 0,
          name: this.userData.department.split("/")[0]
        }]
        this.houseList = this.houseList.concat(res.vo.array)
        // this.houseList = res.vo.array
        this.houseList = util.arrConcatUnRepeat(this.houseList, this.managerStorage)

        // 获取库存
        this.getLists()
      })
    },
    // 当前页
    handleCurrentChange(val) {
      this.currentPage = val
      this.getPaginationData()
    },
    // 搜索筛选新闻数据
    getFilterData() {
      console.log(this.filterName)
      if (this.filterName) {
        // 筛选出所有符合的数据
        this.filterData = []
        for (let i = 0; i < this.listData.length; i++) {
          let _new = this.listData[i]
          if (_new.name.indexOf(this.filterName) != -1) {
            this.filterData.push(_new)
          }
        }
      } else {
        this.filterData = this.listData
      }
      this.currentPage = 1
      this.getPaginationData()
    },
    // 分页筛选数据
    getPaginationData() {
      if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
        this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
      }
      if (this.currentPage == 0) {
        this.currentPage = 1
      }
      // 分页筛选
      this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this
        .currentPage)
    },
    // 获取列表
    getLists() {
      if (!this.time) {
        this.$message.error("请填写时间段，时间段信息不能为空")
        return false;
      }
      this.form.startTime = this.time[0] + " 00:00:00";
      this.form.endTime = this.time[1] + " 23:59:59";
      
      if (this.houseId === 0) {
        // 公司所有仓库
        this.form.depId = this.depId
        this.form.houseId = ''
      } else { }

      this.loading = true
      // this.form.supplierId = this.supplierId == -1 ? '' : this.supplierId
      ajax.get('/storage/material/in/detail/list', this.form, (res) => {
        this.loading = false
        this.filterData = this.listData = res.vo.items
        this.total = {
          sl: res.vo.slTotal,
          zj: res.vo.zjTotal
        }
        this.getFilterData()
      })
    },
  },
  watch: {
    "houseId"() {
      if (this.houseId !== 0) {
        this.form.depId = ''
        this.form.houseId = this.houseId
      } else {
        this.form.depId = this.depId
        this.form.houseId = ""
      }
      this.form.startTime = ''
      this.form.endTime = ''
      this.form.materialName = ''
      this.form.inVoice = ''
      this.form.supplierId = ''
      this.getLists()
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/page/storage/materialInDetailList.vue